import { Layout, Tooltip } from 'antd'
import { MdMenu } from 'react-icons/md'
import { IoMdNotificationsOutline } from 'react-icons/io'

import { Button } from '@/Core/UI/Button'
import { Search } from '@/Ship/Components/UI/Search'
import { useNotificationDrawer } from '@/Containers/CommunicationSection/NotificationContainer/Hooks/useNotificationDrawer'
import { useFavoritesDrawer } from '@/Containers/CommunicationSection/FavoritesContainer/Hooks/useFavoritesDrawer'
import { useMobileMode } from '@/Ship/Hooks/useMobileMode'

import styles from './HeaderContent.module.css'

const { Header } = Layout

interface HeaderContentProps {
    onMenuToggle?: () => void
}

/**
 * Шапка адмінки: пошук і сповіщення; назва розділу живе в шапці сторінки (PageHeader).
 * Профіль, вихід і перемикач теми живуть у блоці користувача внизу сайдбара (UserProfileBlock).
 */
export const HeaderContent = ({ onMenuToggle }: HeaderContentProps) => {
    const { openNotificationDrawer, NotificationBadge, NotificationDrawer } = useNotificationDrawer()
    // Обране приховано разом із кнопкою; дровер лишаємо змонтованим, щоб повернути кнопку без правок.
    const { FavoritesDrawer } = useFavoritesDrawer()
    // On phones the fixed 420px "right" drawer overflows the viewport and the
    // content is not shown — use the full-width "bottom" sheet instead.
    const isMobile = useMobileMode(768)

    return (
        <>
            <Header className={styles['header']}>
                {onMenuToggle && (
                    <button className={styles['menuToggle']} onClick={onMenuToggle} aria-label="Відкрити меню">
                        <MdMenu />
                    </button>
                )}

                <div className={styles['spacer']} />

                <div className={styles['actions']}>
                    <span className={styles['searchWrap']}>
                        <Search width={320} placeholder="Пошук" />
                    </span>
                    {/* open={false} on mobile: touch devices have no hover, and the
                        tooltip would otherwise stick on top of the opened drawer. */}
                    <Tooltip title="Сповіщення" placement="bottom" open={isMobile ? false : undefined}>
                        <span style={{ display: 'inline-flex' }}>
                            <NotificationBadge>
                                <Button
                                    icon={<IoMdNotificationsOutline style={{ fontSize: '20px' }} />}
                                    className={styles['button'] ?? ''}
                                    onClick={openNotificationDrawer}
                                />
                            </NotificationBadge>
                        </span>
                    </Tooltip>
                </div>
            </Header>

            <NotificationDrawer placement={isMobile ? 'bottom' : 'right'} />
            <FavoritesDrawer />
        </>
    )
}
